import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as BackArrow } from "../../Icons/BorderBackArrow.svg";
import { Box, CircularProgress, Typography } from "@mui/material";
import { PrimaryTypography } from "../../Theme";
import { useNavigate, useParams } from "react-router-dom";
import CompanyDetails from "./AddCompanyForms/CompanyDetails";
import ReviewAccount from "./AddCompanyForms/ReviewAccount";
import { emailRegex } from "../../utils/common";
import axiosInstance from "../../AxiosInstance";
import { useDialog } from "../../contexts/DialogContext";
import  { showToast } from "../../CommonComponents/Toaster";

export const reviewstyle = {
  minHeight: "61px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: "10px 0",
};
const EditCompany = () => {
  const [addblocks, setaddblocks] = useState({
    Company_Details: true,

    Review_Information: false,
  });
  const { id } = useParams();
  const topRef = useRef(null);
  const navigate = useNavigate();
  const { showDialog, closeDialog } = useDialog();
  const [pageLoading, setPageLoading] = useState(false);
  const blocks = [
    { status: addblocks.Company_Details, tle: "Company Details" },

    { status: addblocks.Review_Information, tle: "Review Information" },
  ];
  const [companyDetails, setCompanyDetails] = useState({
    company_name: "",
    company_country: "",
    company_email_address: "",
    company_contact_number: "",

    company_address: "",
    company_country_code: "",
  });
  const [loading, setLoading] = useState(false);
  const [errText, setErrText] = useState({
    company_name: "",
    company_country: "",
    company_email_address: "",
    company_contact_number: "",

    company_address: "",
  });
  const [administratorDetails, setAdministratorDetails] = useState({
    full_name: "",
    email_address: "",
  });
  const [administratorErrText, setAdministratorErrText] = useState({
    full_name: "",
    email_address: "",
  });
  const validateCompanyDetails = () => {
    let isValid = true;
    const contactNumberWithoutDialCode =
      companyDetails?.company_contact_number.slice(
        companyDetails?.company_country_code.length
      );

    const errors = {
      company_name: "",
      company_country: "",
      company_email_address: "",
      company_contact_number: "",
      company_contact_countrycode: "",
      company_address: "",
    };

    if (!companyDetails.company_name.trim()) {
      errors.company_name = "Company name is required";
      isValid = false;
    }

    if (!companyDetails.company_country.trim()) {
      errors.company_country = "Country is required";
      isValid = false;
    }
    if (
      companyDetails.company_country.length < 3 ||
      companyDetails.company_country.length > 20
    ) {
      errors.company_country = "Country must be between 3 and 20 characters";
      isValid = false;
    }

    if (!companyDetails.company_email_address.trim()) {
      errors.company_email_address = "Email address is required";
      isValid = false;
    } else if (!emailRegex.test(companyDetails.company_email_address)) {
      errors.company_email_address = "Enter a valid email address";
      isValid = false;
    }

    if (!companyDetails.company_contact_number.trim()) {
      errors.company_contact_number = "Contact number is required";
      isValid = false;
    }

    if (contactNumberWithoutDialCode.length < 6) {
      errors.company_contact_number =
        "Contact number must be at least 6 characters long (excluding dial code)";
      isValid = false;
    }

    if (!companyDetails.company_address.trim()) {
      errors.company_address = "Address is required";
      isValid = false;
    }
    if (companyDetails?.company_name !== "" && errText?.company_name) {
      errors.company_name = "Company name is already existed";
      isValid = false;
    }
    if (
      companyDetails.company_address.length < 3 ||
      companyDetails.company_address.length > 1000
    ) {
      errors.company_address = "Address must be between 3 and 1000 characters";
      isValid = false;
    }
    setErrText(errors);

    return isValid;
  };

  console.log("adminstratorDetails", administratorDetails);
  const Continue = (nxtval) => {
    if (nxtval === "Company Details") {
      setaddblocks({
        Company_Details: true,

        Review_Information: false,
      });
    }

    if (nxtval === "Review Information") {
      if (validateCompanyDetails()) {
        setaddblocks({
          Company_Details: false,

          Review_Information: true,
        });
      }
    }
  };
  const handleAddCompany = async () => {
    setLoading(true);
    const companyData = {
      name: companyDetails?.company_name,
      email: companyDetails?.company_email_address,
      phone: companyDetails?.company_contact_number.slice(
        companyDetails?.company_country_code.length
      ),
      country_code: companyDetails?.company_country_code,
      address: companyDetails?.company_address,
      country: companyDetails?.company_country,
    };
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}company/${id}`,
        companyData
      );
      navigate("/company");
      showDialog({
        title: "Company Updated",
        content: "This company has been successfully updated to the list.",
      });
      setLoading(false);
      console.log(response.data);
    } catch (error) {
      console.error(error);
      if (error.response) {
        if (error.response.status === 400) {
          const { validation_error } = error.response.data?.data;

          if (validation_error) {
            const updatedErrText = { ...errText };
            Object.keys(validation_error).forEach((key) => {
              if (key === "name") {
                updatedErrText.company_name = "Company name is already existed";
                showToast("Company name is already existed", "error");
              }
            });

            setErrText(updatedErrText);

            setaddblocks({
              Company_Details: true,

              Review_Information: false,
            });
          }
        }
        if (error.response.status === 500) {
          showToast("Something went wrong! Please try again.", "error");
        }
      }

      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  const RenderComponent = () => {
    switch (true) {
      case addblocks.Company_Details:
        return (
          <CompanyDetails
            companyDetails={companyDetails}
            errText={errText}
            setErrText={setErrText}
            setCompanyDetails={setCompanyDetails}
            setaddblocks={setaddblocks}
          />
        );

      case addblocks.Review_Information:
        return (
          <ReviewAccount
            administratorDetails={administratorDetails}
            companyDetails={companyDetails}
            setaddblocks={setaddblocks}
            errText={errText}
            setErrText={setErrText}
            loading={loading}
            handleSubmit={handleAddCompany}
          />
        );
      default:
        return null;
    }
  };
  const getCompanyData = () => {
    setPageLoading(true);
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}company/${id}`)
      .then((res) => {
        setCompanyDetails({
          company_name: res.data?.data?.company?.name,
          company_country: res?.data?.data?.company?.country,
          company_email_address: res?.data?.data?.company?.email,
          company_contact_number: `${res?.data?.data?.company?.country_code}${res?.data?.data?.company?.phone}`,
          company_country_code: res?.data?.data?.company?.country_code,
          company_address: res?.data?.data?.company?.address,
        });
        setPageLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setPageLoading(false);
      });
  };
  useEffect(() => {
    getCompanyData();
  }, []);
  useEffect(() => {
    if (topRef.current) {
      topRef.current.scrollIntoView({
        behavior: "smooth",
      });
    }
  }, [addblocks]);
  console.log("companyDetails", companyDetails);
  return pageLoading ? (
    <Box
      sx={{ width: "100%", height: "90vh" }}
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <CircularProgress />
    </Box>
  ) : (
    <div ref={topRef}>
   
      <Box>
        <BackArrow
          onClick={() => navigate("/company")}
          style={{ marginBottom: "20px", cursor: "pointer" }}
        />
        <PrimaryTypography>Edit Company Details</PrimaryTypography>
      </Box>
      <Box sx={{ marginTop: "30px" }} display="flex" gap="1.5%" mb={5}>
        {blocks.map((itm) => (
          <Box
            key={itm.tle}
            onClick={() => Continue(itm.tle)}
            sx={{
              borderTop: itm.status ? "3px solid #0E4965" : "3px solid #D2D6DB",
              width: "50%",
              color: itm.status ? "#0E4965" : "#D2D6DB",
              cursor: "pointer",
            }}
          >
            <Typography
              sx={{
                fontWeight: "500",
                fontSize: "12px",
                color: itm.status ? "#0E4965" : "#9DA4AE",
                padding: "10px 0 0 0",
              }}
            >
              {itm.tle}
            </Typography>
          </Box>
        ))}
      </Box>
      {RenderComponent()}
    </div>
  );
};

export default EditCompany;
